import { gql } from '@apollo/client';

export const CREATE_INQUIRY = gql`
  mutation createInquiry($data: CreateInquiryInput!) {
    createInquiry(data: $data) {
      id
      inquiryNumber
    }
  }
`;

export const UPDATE_INQUIRY = gql`
  mutation updateInquiry($where: UpdateInquiryWhereInput!, $data: UpdateInquiryInput!) {
    updateInquiry(where: $where, data: $data) {
      id
      inquiryNumber
    }
  }
`;

export const INQUIRY_LIST = gql`
  subscription inquiryList($where: inquiry_bool_exp, $order_by: [inquiry_order_by!]) {
    inquiry(where: $where, order_by: $order_by) {
      id
      inquirerName
      firstName
      lastName
      inquirerEmail
      inquiryNumber
      studentEmail
      date
      student_registered {
        id
      }
      course {
        id
        name
      }
      intake {
        id
        name
      }
      status
      studentId
    }
  }
`;

export const DELETE_INQUIRY = gql`
  mutation deleteInquiry($where: inquiry_bool_exp!) {
    delete_inquiry(where: $where) {
      affected_rows
    }
  }
`;

export const INQUIRY = gql`
  query inquiry($where: inquiry_bool_exp) {
    inquiry(where: $where) {
      id
      inquiryNumber
      inquirerName
      firstName
      middleName
      lastName
      city
      date
      inquirerContactNo
      inquirerEmail
      dateOfBirth
      gender
      education_qualifications {
        id
        name
        schoolOrInstitute
        yearOfCompletion
        gradings
      }
      employment_experiences {
        id
        startDate
        endDate
        position
        company
        duties
        references
      }
      course {
        id
      }
      preferredYear
      intake {
        id
      }
      willingToMigrate
      assignedUserId
      inquiryType
      referredVia
      parentOrGuardianLandLineNo
      parentOrGuardianMobileNo
      whatsapp_number
      landLineNo
      mobileNo
      studentEmail
    }
  }
`;
